var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.615 5.885H6a.5.5 0 0 0-.5.5V19a.5.5 0 0 0 .5.5h12.615a.5.5 0 0 0 .5-.5V6.385a.5.5 0 0 0-.5-.5M6 4.385a2 2 0 0 0-2 2V19a2 2 0 0 0 2 2h12.615a2 2 0 0 0 2-2V6.385a2 2 0 0 0-2-2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.846 2.25a.75.75 0 0 1 .75.75v1.385a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75m6.924 0a.75.75 0 0 1 .75.75v1.385a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 5h15v4H5z"
})));
export default SvgCalendar;